import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BrandingService } from '../../../pages/branding/branding.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { InFaxService } from '../../../pages/infax/infax.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  private subscription: Subscription //import from rxjs 
  domain_title: string = 'Unitecom Fax';
  auser: any;
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: this.translate.instant('general.change_pass'), link: '/pages/Changepass' }, { title: this.translate.instant('general.log_out'), link: 'auth/logout' }];

  image_url = "../../../../assets/images/ictfax-logo.png";
  inbound_faxs: any = 0;

  constructor(private sidebarService: NbSidebarService,
    private infax: InFaxService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService, private authService: NbAuthService,
    private router: Router, private nbMenuService: NbMenuService,
    private branding_service: BrandingService, public translate: TranslateService, private app_service: AppService,) {

    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {

        if (token.isValid()) {
          this.auser = token.getPayload(); // here we receive a payload from the token and assigns it to our `user` variable
          localStorage.setItem('username', this.auser.username);
          localStorage.setItem('is_admin', this.auser.is_admin);
          localStorage.setItem('is_tenant', this.auser.is_tenant);
          localStorage.setItem('aid', this.auser.user_id);
          localStorage.setItem('tid', this.auser.tenant_id);
          localStorage.setItem('permission', "");
          if (this.auser.user_permission) localStorage.setItem('permission', this.auser.user_permission);
          this.get_domain_title(this.auser.tenant_id);
          // const brand:any = this.get_domain_title(this.auser.tenant_id);
          // if (!brand) this.get_domain_title(0);
          this.image_url = `${this.app_service.apiUrlBranding}/${this.auser.tenant_id}/media`;
        }

      });
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    // this.Notification()

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.subscription = this.nbMenuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        if (title == 'Log out') {
          let copy_token = localStorage.getItem('copy_token');
          if (copy_token != null) {
            localStorage.removeItem('copy_token');
            window.location.reload();

            this.authService.getToken()
              .subscribe((token: NbAuthJWTToken,
              ) => {
                if (token && token.getValue()) {
                  let auser = token.getPayload();
                  localStorage.setItem('username', auser.username);
                  localStorage.setItem('is_admin', auser.is_admin);
                }
              });

            this.router.navigate(['/dashboard']);

          }
          else {
            this.router.navigate(['auth/logout']);
          }
        }
      });
  }
  handleBellIcon() {
    this.router.navigate(['../pages/infax']);
    this.inbound_faxs = 0;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }
  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  ngDoCheck() {
    let myname = localStorage.getItem('username');
    if (myname != undefined) {
      this.auser.username = myname;
    }
  }
  get_domain_title(tenant_id) {
    this.branding_service.get_Branding(tenant_id).then(response => {
      document.title = response.title;
      this.domain_title = response.title;
    });
  }
  // Notification() {
  //   this.infax.count().then(response => {
  //     // console.log(response.Inbound_faxs);
  //     this.inbound_faxs = response.Inbound_faxs;

  //   })
  // }
}
